
import ScanImg from "@/assets/scan.png";
import CHeader from "@/components/HeaderMag";
import CPosition from "@/components/Position";
import { formatDate } from "@utils";
import { scanQRCode } from "@utils/wechat";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Order",
components: {
Group,
Cell,
XInput,
XButton,
CHeader,
XTable,
CPosition,
},

data() {
return {
list: [],
StoreCode: "",
ScanImg: ScanImg,
ID: "",
scan_type: 1,
};
},
created() {
this.$store.dispatch('baiduPosition')
},
computed: {
position() {
return this.$store.getters.getPosition;
},
},
methods: {
openScan() {
if (!this.position.addr) {
this.$toast.text("请等待拿到位置信息后再进行扫码上报位置");
return;
}
let _this = this;
scanQRCode(_this.scan_type).then((res) => {
console.log("scan result", res);
this.StoreCode = res;
if(this.StoreCode.length<13){
this.$toast.text("条码格式不正确！");
return;
}
_this.parseScanRes(res);
});
},
parseScanRes(res) {
let _this = this;
_this.loadData(res);
},

loadData() {
let _this = this;
_this.$vux.loading.show();
let url = "Trans.ashx?action=GetStore";
if(this.StoreCode.indexOf('CODE_128,')!='-1'){
this.StoreCode=this.StoreCode.replace('CODE_128,','')
}
return this.$post(url, {
StoreCode: this.StoreCode,
})
.then((response) => {
let res=JSON.parse(response)
if (res.Table.length == 0) {
_this.$toast.text("扫码结果" + this.StoreCode + "未匹配到信息");
return;
} else {
if(res.Table[0].STORECODE=='03287'){
res.Table[0].AREASNAME='郑州'
}
res.Table[0].scan = this.StoreCode;
res.Table[0].time = this.getNowDate();
this.list.unshift(res.Table[0]);
}
})
.catch((response) => {
this.$toast.warn("未获取到有效数据");
console.log(response, "请求失败");
});
},
getNowDate() {
var myDate = new Date();
var year = myDate.getFullYear(); 
var mon = myDate.getMonth() + 1; 
var date = myDate.getDate(); 
var hours = myDate.getHours(); 
var minutes = myDate.getMinutes(); 
var seconds = myDate.getSeconds(); 
var now =
year +
"-" +
mon +
"-" +
date +
" " +
hours +
":" +
minutes +
":" +
seconds;
return now;
},
},
};



// WEBPACK FOOTER //
// ./src/pages/ctd/Store.vue